/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pos_Order_Subtotal_LabelInputs */

const vi_pos_order_subtotal_label = /** @type {(inputs: Pos_Order_Subtotal_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng tiền hàng (${i?.count})`)
};

/**

* @param {Pos_Order_Subtotal_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_order_subtotal_label = /** @type {((inputs: Pos_Order_Subtotal_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Order_Subtotal_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_order_subtotal_label(inputs)
});